export const SUPER_ADMIN = 'SUPER_ADMIN';
export const ADMIN = 'ADMIN';
export const RESPONSABILE = 'TEACHER';
export const NEWTON = 'ANALYTICS';
export const EDITOR = 'MANAGER';
export const PARTECIPANT = 'PARTECIPANT';
